/* 布局 */
//前台
import Layout from "@views/layout";

const communityregionnodeRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "communityregionnode/list",
        name: "COMMUNITYREGIONNODE",
        meta: {
            title: "区域管理",
            keepAlive:true
        },
        component: () => import("@views/business/communityregionnode/index.vue"),
    },
        ],
};

export default communityregionnodeRouter;
